// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"5c9bfcca","245":"8ee5b087","267":"dec39db3","286":"cee9a0bb","452":"5bbce003","622":"94298c96","787":"e24b9d2f"}[chunkId] + ".chunk.js";
};